export default [

  {
    path: '/finance/revenueList',
    meta: {
      title: '营收统计',
    },
    component: () => import('@/views/finance/revenueList'),
  },
  {
    path: '/finance/invoiceList',
    meta: {
      title: '开票记录',
    },
    component: () => import('@/views/finance/invoiceList/list'),
  },
  {
    path: '/finance/dealList',
    meta: {
      title: '交易明细',
    },
    component: () => import('@/views/finance/dealList'),
  },
  {
    path: '/finance/behalof',
    meta: {
      title: '转账记录'
    },
    component: () => import('@/views/finance/behalof')
  },
  //----------内页
  {
    path: '/finance/invoiceApply',
    meta: {
      title: '申请开票',
    },
    component: () => import('@/views/finance/invoiceApply/list'),
  },
  {
    path: '/finance/billManagement',
    meta: {
      title: '账单管理',
    },
    component: () => import('@/views/finance/billManagement/index'),
  },
  {
    path: '/finance/serviceCharge',
    meta: {
      title: '服务费',
    },
    component: () => import('@/views/finance/serviceCharge/index'),
  },
  // 20230725 zmd 共享推送
  // {
  //   path: '/finance/serviceCharge',
  //   meta: {
  //     title: '共享推送',
  //   },
  //   component: () => import('@/views/finance/sharefeeds/sharefeeds'),
  // },
  {
    path: '/finance/sharefeeds',
    meta: {
      title: '共享推送',
    },
    component: () => import('@/views/finance/sharefeeds/sharefeeds'),
  },
  {
    path: '/finance/transactionFlow',
    meta: {
      title: '订单交易流水',
    },
    component: () => import('@/views/finance/transaction-flow'),
  },
  {
    path: '/finance/monthTransactionFlow',
    meta: {
      title: '订单月度交易流水',
    },
    component: () => import('@/views/finance/month-transaction-flow'),
  },
  {
    path: '/finance/monthTransactionRecord',
    meta: {
      title: '订单月度交易记录',
    },
    component: () => import('@/views/finance/month-transaction-record'),
  },
  {
    path: '/finance/orderFlow',
    meta: {
      title: '工单交易流水',
    },
    component: () => import('@/views/finance/order-flow'),
  },
  {
    path: '/finance/monthOrderRecord',
    meta: {
      title: '工单月度交易记录',
    },
    component: () => import('@/views/finance/month-order-flow'),
  },
]